import { Sub } from './editor/editor'

export function debugDraw(
  c: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  s: Sub
) {
  c.save()
  c.strokeStyle = c.fillStyle = '#fff'

  const fontSize = 11.9
  c.font = `500 ${fontSize}px 'Jost', sans-serif`

  c.textBaseline = 'top'
  c.lineWidth = fontSize / 150

  const message = s.meta.out

  c.fillText(
    message,
    x,
    y + 2,
  )

  c.strokeText(
    message,
    x,
    y + 2,
  )
  c.restore()
}

